import { useEffect, useState } from "react";
import { fetchData, fetchTeamSpace } from "../api/client";

/**
 * Espaço ativo + membros + id do usuário impersonado no tenant (console plataforma / portal revenda).
 */
export function usePortalTeamActiveSpace(spaceId, company) {
  const [space, setSpace] = useState(null);
  const [members, setMembers] = useState([]);
  const [tenantUserId, setTenantUserId] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!company) {
      setTenantUserId(null);
      return;
    }
    fetchData("/users/me", "GET", null, { company: String(company).trim() })
      .then((me) => {
        const raw = me?.id ?? me?.data?.id ?? null;
        const n = Number(raw);
        setTenantUserId(Number.isFinite(n) && n > 0 ? n : null);
      })
      .catch(() => setTenantUserId(null));
  }, [company]);

  useEffect(() => {
    const sid = Number(spaceId);
    if (!company || !Number.isFinite(sid) || sid <= 0) {
      setSpace(null);
      setMembers([]);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    fetchTeamSpace(sid, company)
      .then((res) => {
        if (cancelled) return;
        setSpace(res?.space || null);
        setMembers(Array.isArray(res?.members) ? res.members : []);
      })
      .catch(() => {
        if (cancelled) return;
        setSpace(null);
        setMembers([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [spaceId, company]);

  return { space, members, tenantUserId, loading };
}
